import type { FilterSet, RequestState } from '../types';

export function buildInitialFilterSetState(): FilterSet {
  return {
    bedrooms: 1,
    bathrooms: 1,
    amenities: [],
    distance_to_beach: 0,
    accommodation_type: [],
    stars: 0,
  };
}

const initialState: RequestState = {
  page: 1,
  countryCode: '',
  region: '',
  city: '',
  arrival: null,
  durationOfStay: null,
  occupancy: 2,
  filterSet: buildInitialFilterSetState(),
  options: {
    countries: [],
    regions: [],
    cities: [],
  },
};

export default initialState;
